import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']
  static values = { activeTab: String, pageId: String, jurisdictionId: String }

  connect() {
    const pageId = this.pageIdValue || 'default'
    const storageKey = `admin-tabs-${pageId}`
    const jurisdictionKey = `admin-current-jurisdiction`

    const lastJurisdictionId = sessionStorage.getItem(jurisdictionKey)

    let initialTab

    if (lastJurisdictionId !== this.jurisdictionIdValue) {
      // Different jurisdiction - reset to default tab and clear saved state
      sessionStorage.removeItem(storageKey)
      initialTab = this.activeTabValue || this.tabTargets[0].dataset.tab
    } else {
      // Same jurisdiction - use saved tab if available
      const savedTab = sessionStorage.getItem(storageKey)
      initialTab =
        savedTab || this.activeTabValue || this.tabTargets[0].dataset.tab
    }

    sessionStorage.setItem(jurisdictionKey, this.jurisdictionIdValue)

    this.showTab(initialTab)
  }

  switch(event) {
    event.preventDefault()
    const tabName = event.currentTarget.dataset.tab
    this.showTab(tabName)
  }

  showTab(tabName) {
    // Save the active tab to sessionStorage
    const pageId = this.pageIdValue || 'default'
    const storageKey = `admin-tabs-${pageId}`
    sessionStorage.setItem(storageKey, tabName)

    // Update active tab state
    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.tab === tabName

      if (isActive) {
        // Active tab styles
        tab.classList.remove(
          'border-transparent',
          'text-gray-500',
          'hover:border-gray-300',
          'hover:text-gray-700'
        )
        tab.classList.add('border-indigo-500', 'text-indigo-600')
        tab.setAttribute('aria-current', 'page')
      } else {
        // Inactive tab styles
        tab.classList.remove('border-indigo-500', 'text-indigo-600')
        tab.classList.add(
          'border-transparent',
          'text-gray-500',
          'hover:border-gray-300',
          'hover:text-gray-700'
        )
        tab.removeAttribute('aria-current')
      }
    })

    // Show/hide panels
    this.panelTargets.forEach((panel) => {
      if (panel.dataset.panel === tabName) {
        panel.classList.remove('hidden')
      } else {
        panel.classList.add('hidden')
      }
    })

    // Update the select dropdown for mobile
    const select = this.element.querySelector('select')
    if (select) {
      select.value = tabName
    }
  }

  // Handle mobile select dropdown
  selectChanged(event) {
    this.showTab(event.target.value)
  }
}
